<div class="p-fluid">
  <p class="font-bold text-lg">Вы действительно хотите удалить контрагента?</p>
  <p class="mt-2 text-gray-400">
    Выберите контрагента, к которому перейдут все связанные объекты, в том числе и платежные аккаунты удаленного
    контрагента.
  </p>

  <div class="field mt-3">
    <label class="font-medium required-field">Контрагент</label>
    <crm-contragent-auto-complete
      [(selectedContragent)]="contragent"
      [excludeIds]="previousContragentIds"
      [customSearch]="false"
      appendTo="body"></crm-contragent-auto-complete>
  </div>
</div>

<div class="flex justify-content-end gap-3 mt-5">
  <crm-button
    icon="pi pi-times"
    label="Отмена"
    styleClass="p-button-danger p-button-outlined"
    (onClick)="ref?.close()"></crm-button>

  <crm-button
    icon="pi pi-check"
    label="Удалить"
    styleClass="p-button-success"
    [disabled]="!contragent"
    (onClick)="ref?.close(contragent)"></crm-button>
</div>
